import { Link } from "react-router-dom";
import { STEPS } from "../../data/promill";

export const HowItWorks = () => (
    <section
        id="how-it-works"
        data-testid="how-it-works-section"
        className="relative bg-pm-yellow text-pm-black py-20 md:py-28 overflow-hidden border-y-[3px] border-pm-black"
    >
        <div aria-hidden className="absolute inset-0 grain" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
                <div>
                    <span className="inline-block bg-pm-black text-pm-yellow font-bold tracking-[0.3em] uppercase text-xs px-3 py-1 mb-4">
                        How It Works
                    </span>
                    <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.95]">
                        Clean food,<br />
                        <span className="italic">simply served.</span>
                    </h2>
                </div>
                <p className="max-w-md text-base md:text-lg font-medium">
                    Discover meals crafted for real Indian bodies — every bowl capped at 500 kcal
                    and packed with at least 25g of clean protein.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {STEPS.map((s, i) => (
                    <div
                        key={s.n}
                        data-testid={`step-${i}`}
                        className="relative bg-pm-cream border-[3px] border-pm-black rounded-2xl p-7 card-lift shadow-[6px_6px_0_0_#0A0A0A]"
                    >
                        <div className="font-display text-6xl text-pm-green leading-none">{s.n}</div>
                        <h3 className="font-display text-2xl uppercase mt-3">{s.title}</h3>
                        <p className="mt-2 text-sm text-pm-black/75">{s.desc}</p>
                        {i < STEPS.length - 1 && (
                            <div className="hidden lg:block absolute -right-5 top-1/2 -translate-y-1/2 text-pm-black font-display text-4xl">
                                →
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="mt-12 flex justify-center">
                <Link to="/menu" data-testid="how-it-works-cta" className="btn-brutal btn-brutal--dark">
                    Explore Menu →
                </Link>
            </div>
        </div>
    </section>
);
